import { CountResponse } from '@interfaces/common.interface';
import {
  CountDrugsRequestParams,
  CreateDrugRequest,
  Drug,
  GetDrugsRequestParams,
  UpdateDrugRequest,
} from '@interfaces/drugs.interface';

import api from './';

export const {
  useCountDrugsQuery,
  useGetManyDrugsQuery,
  useCreateDrugMutation,
  useUpdateDrugMutation,
  useDeleteDrugMutation,
  useGetDrugsLastImportDateQuery,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countDrugs: build.query<CountResponse, CountDrugsRequestParams>({
      query: (params) => ({ url: 'drugs/count', params }),
      providesTags: ['drugs'],
    }),
    getManyDrugs: build.query<Drug[], GetDrugsRequestParams>({
      query: (params) => ({ url: 'drugs', params }),
      providesTags: ['drugs'],
    }),
    createDrug: build.mutation<Drug, CreateDrugRequest>({
      query: (body) => ({
        url: 'drugs',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['drugs'],
    }),
    updateDrug: build.mutation<Drug, UpdateDrugRequest>({
      query: ({ aic, body }) => ({
        url: `drugs/${aic}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['drugs'],
    }),
    deleteDrug: build.mutation<Drug, string>({
      query: (aic) => ({
        url: `drugs/${aic}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['drugs'],
    }),
    getDrugsLastImportDate: build.query<string, void>({
      query: () => ({ url: 'drugs/last-import-date' }),
    }),
  }),
});
